import React from "react"
import { useSelector } from "react-redux"
import { formSubmissionClosed } from "reduxSlices/formSubmissionSlice"
import StrikeAround from "shared/StrikeAround"
import ConversationList from "./ConversationList"
import OpenConversation from "./OpenConversation"

const ConversationsSection = () => {
  const formSubmissionIsClosed = useSelector(formSubmissionClosed)

  return (
    <div>
      <StrikeAround className="mb-6">
        <h3>Conversations with the Submitter</h3>
      </StrikeAround>
      <ConversationList className="mb-8" />
      {
        !formSubmissionIsClosed && (
          <OpenConversation />
        )
      }
    </div>
  )
}

export default ConversationsSection
